<template>
	<div>
		<!--导航-->
		<nav class="navbar navbar-expand-md mynav navbar-light fixed-top">
			<a class="navbar-brand" href="#">
				<img class="" src="../../../static/images/logo.png" />
			</a>
			<!-- 按钮边框 -->
			<button class="navbar-toggler " type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
            <!-- 方框里面三条线 -->
			<span class="navbar-toggler-icon"></span>
	    	</button>
			<div class="collapse navbar-collapse" id="collapsibleNavbar">
				<ul class="navbar-nav" style="margin: 0 auto;">
					<li v-for="(item,index) in tit">
						<router-link :to="{path: item.path}" replace>
							<span :class="{active: item.path === $route.path}">{{item.name}}<i class="on"></i></span>
						</router-link>
					</li>
					<li class="img">
						<span><img class="img-fluid " style="width: 22px;" src="../../../static/images/phone.png" /></span>
						<span style="margin-left: 2px;">0757-8992 5781</span>
					</li>
				</ul>
			</div>
		</nav>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tit: [{
						name: "首页",
						path: '/'
					},
					{
						name: "新闻资讯",
						path: '/news'
					},
					{
						name: "产品中心",
						path: '/product'
					},
					{
						name: "招商加盟",
						path: '/join'
					},
					{
						name: "关于我们",
						path: '/about'
					},
				]
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {},
	}
</script>

<style scoped lang="less">
	@w: 19.2vw;
	nav {
		height: 68px;
		ul {
			height: 100%;
			line-height: 52px;
		}
	}
	
	.mynav {
		background: rgba(255, 255, 255, .8);
	}
	
	.active {
		.on {
			display: block;
			position: absolute;
			left: 0;
			bottom: -8px;
			width: 100%;
			height: 5px;
			background: #166BAB;
			&:after {
			content: "";
			border: 10px solid transparent;
			border-bottom-color: #166BAB;
			position: absolute;
			top: 0;
			left: 40px;
			margin-top: -19px;
			}
		
		}
	}
	
	.navbar-brand {
		img {
			width: 180px;
		}
	}
	
	ul {
		li {
			width: 100px;
			text-align: center;
			position: relative;
			/*line-height: 100px;*/
			a {
				display: block;
				color: #616161;
				font-size: 18/@w;
				text-decoration: none;
			}
			a:hover{
			color: #166BAB;
			font-weight: bold;
		  }
		}
	}
	
	@media screen and (max-width: 768px) {
		ul {
			li {
				width: 80px;
				margin-top: 10px;
			}
		}
	}
	
	@media screen and (max-width: 475px) {
		nav {
			height: 40px;
			padding: 0 20px;
			button {
				padding: 2px;
				font-size: 16px;
			}
			.navbar-brand {
				img {
					width: 90px;
				}
			}
		}
	}
	
	.img {
		color: #616161;
		font-size: 12/@w;
		width: 150px;
	}
</style>


// WEBPACK FOOTER //
// src/components/navHeader/index.vue